import { DESKTOP_SPACING, FONT_SIZE, NATURAL, PRIMARY_BLUE, SECONDARY_RED } from '@/theme';

import { StyledInputProps } from './InputText.interface';
import styled from 'styled-components';

export const StyledInputText = styled.input<StyledInputProps>`
  background: ${NATURAL.B};
  border-radius: 4px;
  border: 1px solid ${({ state }) => state === 'error' ? SECONDARY_RED.DEFAULT : NATURAL.C};
  box-shadow: none;
  caret-color: ${PRIMARY_BLUE.DARK};
  color: ${NATURAL.I};
  display: block;
  font-size: ${FONT_SIZE.SM};
  height: 44px;
  line-height: 22px;
  margin: ${DESKTOP_SPACING.XXL}px 0;
  outline: none;
  padding: ${DESKTOP_SPACING.LG}px;
  width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};

  ${({ state }) => state === 'error' ? `box-shadow: 0px 0px 0px 2px ${SECONDARY_RED.LIGHTER};` : ''}

  &:focus {
    border: 1px solid ${PRIMARY_BLUE.DARK};
    box-shadow: 0px 0px 0px 2px ${PRIMARY_BLUE.LIGHT};
  }

  ::placeholder {
    opacity: 0;
  }

  :focus::placeholder {
    opacity: 1;
  }
`;
